import BaseComponent from "./BaseComponent";
import Input from "./Input";
import Dropdown from "./Dropdown";
import Switch from "./Switch";
export default class NestedProperties extends BaseComponent {
    /**
     * Component for managing nested property views 
     * Currently renders inputs, dropdowns, and labels
     * @module NestedProperties
     * @param {Object} props React props
     */

    constructor(props) {
        super(props);
        this.propList = this.props.value ? this.props.value : {};
        this.nestedProps = this.props.nestedprops ? this.props.nestedprops : [];
        this.state = {
            propsList: this.props.value ? this.props.value : {}
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickOutsideHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickOutsideHandler);
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string} value
     */
    // TODO: UsedIn
    setConfig(key, value) {
        this.propList[key] = value;
        this.updateContext(this.propList);
    }

    /**
     * Get config proxy
     * @param {string} key
     * @returns {string}
     */
    getConfig(key) {
        return this.propList[key];
    }

    /**
     * Render one component of the key-value group
     * @param {Object} viewConfig View configuration
     * @returns {XML}
     */
    renderComponent(viewConfig) {
        const hint = viewConfig.hasOwnProperty("hint") ? viewConfig.hint : "";
        switch (viewConfig.type) {
            case "Input":
                const valRules = viewConfig.hasOwnProperty("valRules") ? viewConfig.valRules : {};
                const inputRules = viewConfig.hasOwnProperty("inputRules") ? viewConfig.inputRules : {};
                return <Input
                        label={viewConfig.label}
                        hint={hint}
                        context={this}
                        valKey={viewConfig.key}
                        suggestion={viewConfig.suggestion || "variable"}
                        value={this.getConfig(viewConfig.key)}
                        valRules={valRules}
                        inputRules={inputRules}
                        disabled={viewConfig.disabled}
                        isPropertyPanel={true}
                        />;
            case "Switch":
                return <Switch 
                    context={this}
                    valKey={viewConfig.key}
                    checked={this.state.pairValueView.value}
                    disabled={viewConfig.disabled || this.pair.key === "none"}
                />
            case "Dropdown":
                const selection = viewConfig.value
                const options = viewConfig.options;
                const selectedOption = options.findIndex(opt => opt.value === selection);
                return <Dropdown
                    label={viewConfig.label}
                    optionName={viewConfig.optionName}
                    context={this}
                    valKey={viewConfig.key}
                    options={viewConfig.options}
                    selection={selectedOption}
                    readOnly={viewConfig.disabled} />;

            case "Label":
                return (
                    <div className="form-component-container">
                        <div className="form-component label">{this.getConfig(viewConfig.key)}</div>
                    </div>
                );
        }
    }

    getLabel(){
        const layout = this.props.layout || 'default';

        if (layout === 'keyedLabel') {
            return this.renderKeyedLabel();
        } else {
            return <label>{this.props.label}</label>;
        }
    }

    renderDefaultUI(){

        const allProperties = this.props.nestedProps

        return (
            <div className="form-component-container">
                {this.getLabel()}
                <table className="key-value">
                    <tbody>
                        {
                            allProperties.map((property,i) => {
                            return  <tr key={property.key+i}>
                                        <td key={property.key}>{this.renderComponent(property)}</td>
                                    </tr>;
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return this.renderDefaultUI();
    }
}
